export default class LocationMapMultiple {
  constructor() {
    this.mapEl = document.querySelector(".js-tab-map");
    this.tabItem = Array.from(document.querySelectorAll(".tabMaps__tabitem"));
    this.marker = null;
    this.overlayUrl = `${CCM_BASE_URL +
      CCM_REL}/themes/ddw_theme/dist/images/DXBDW23_Map.png`;

    this.mapStyle = [
      { elementType: "labels.text", stylers: [{ visibility: "off" }] },
      {
        featureType: "landscape.natural",
        elementType: "geometry.fill",
        stylers: [{ color: "#f5f5f2" }, { visibility: "on" }],
      },
      { featureType: "administrative", stylers: [{ visibility: "off" }] },
      { featureType: "transit", stylers: [{ visibility: "off" }] },
      { featureType: "poi.attraction", stylers: [{ visibility: "off" }] },
      {
        featureType: "landscape.man_made",
        elementType: "geometry.fill",
        stylers: [{ color: "#ffffff" }, { visibility: "on" }],
      },
      { featureType: "poi.business", stylers: [{ visibility: "off" }] },
      { featureType: "poi.medical", stylers: [{ visibility: "off" }] },
      { featureType: "poi.place_of_worship", stylers: [{ visibility: "off" }] },
      { featureType: "poi.school", stylers: [{ visibility: "off" }] },
      { featureType: "poi.sports_complex", stylers: [{ visibility: "off" }] },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.arterial",
        stylers: [{ visibility: "simplified" }, { color: "#ffffff" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.icon",
        stylers: [{ color: "#ffffff" }, { visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      { featureType: "road.arterial", stylers: [{ color: "#ffffff" }] },
      { featureType: "road.local", stylers: [{ color: "#ffffff" }] },
      {
        featureType: "poi.park",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      { featureType: "water", stylers: [{ color: "#71c8d4" }] },
      { featureType: "landscape", stylers: [{ color: "#e5e8e7" }] },
      { featureType: "poi.park", stylers: [{ color: "#8ba129" }] },
      { featureType: "road", stylers: [{ color: "#ffffff" }] },
      {
        featureType: "poi.sports_complex",
        elementType: "geometry",
        stylers: [{ color: "#c7c7c7" }, { visibility: "off" }],
      },
      { featureType: "water", stylers: [{ color: "#a0d3d3" }] },
      { featureType: "poi.park", stylers: [{ color: "#91b65d" }] },
      { featureType: "poi.park", stylers: [{ gamma: 1.51 }] },
      { featureType: "road.local", stylers: [{ visibility: "off" }] },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.government",
        elementType: "geometry",
        stylers: [{ visibility: "off" }],
      },
      { featureType: "landscape", stylers: [{ visibility: "off" }] },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ visibility: "simplified" }],
      },
      { featureType: "road.local", stylers: [{ visibility: "simplified" }] },
      { featureType: "road" },
      { featureType: "road" },
      {},
      { featureType: "road.highway" },
    ];

    if (this.mapEl) {
      this.initMaps();
    }
  }

  initMaps() {
    this.office = [];
    this.marker = [];
    this.allMarkers = [];
    this.infowindow = [];
    this.mapIconUrl = `${CCM_BASE_URL +
      CCM_REL}/themes/ddw_theme/dist/images/pin-hover.png`;

    this.mapIcon = {
      url: this.mapIconUrl,
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(15, 15),
    };

    this.arrayOfCoords = [];

    this.map = new google.maps.Map(this.mapEl, {
      zoom: 18,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
        style: google.maps.ZoomControlStyle.SMALL,
      },
      scaleControl: false,
      fullscreenControl: false,
      scrollwheel: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: this.mapStyle,
      panControl: true,
      mapTypeControl: false,
      panControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
      },
      streetViewControl: false,
    });

    this.tabItem.forEach((currentValue, index) => {
      this.tabItem[0].classList.add("active");

      let rawCoords = this.tabItem[index]
        .getAttribute("data-coords")
        .replace(" ", "")
        .split(",");

      // console.log(new google.maps.LatLng(rawCoords[0], rawCoords[1]).getNorthEast());
      rawCoords =
        rawCoords.length === 2
          ? { lat: parseFloat(rawCoords[0]), lng: parseFloat(rawCoords[1]) }
          : null;
      // let boundz = new google.maps.LatLngBounds(southWest, northEast);
      // console.log(boundz);

      this.arrayOfCoords.push(rawCoords);
      this.office[index] = new google.maps.LatLng(rawCoords);

      this.marker[index] = new google.maps.Marker({
        position: this.office[index],
        map: this.map,
        animation: google.maps.Animation.DROP,
        icon: this.mapIcon,
      });

      this.infowindow[index] = new google.maps.InfoWindow({
        content: `
                <div id="iw-container">
                    <div class="iw-content">
                        <h5 class="iw-type">${this.tabItem[index].getAttribute(
                          "data-type"
                        )}</h5>
                        <h4 class="iw-title">${this.tabItem[index].getAttribute(
                          "data-title"
                        )}</h4>
                        <p class="iw-date">${this.tabItem[index].getAttribute(
                          "data-date"
                        )}</p>
                        <p class="iw-location"><a href="https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${
                          this.arrayOfCoords[index].lat
                        },${
          this.arrayOfCoords[index].lng
        }" target="_blank" class="linkHoverX-style2">${this.tabItem[
          index
        ].getAttribute("data-location")}</a></p>
                    </div>
                </div>
            `,
        maxWidth: 200,
        position: this.office[index],
      });
      this.allMarkers.push(this.marker);
      // this.locationButton.attr('href', this.directionsUrl + this.tabItem[0].getAttribute('data-coords'));

      //Toggle Map
      this.tabItem[index].addEventListener("click", (e) => {
        let curIndex = $(e.currentTarget).index();

        $(e.currentTarget)
          .addClass("active")
          .siblings()
          .removeClass("active");
        // that.locationButton.attr('href', that.directionsUrl + $(e.currentTarget).data('coords'));

        //Hide All Markers
        this.hideAllMarkers();

        //Set Visible The Current One
        this.marker[curIndex].setVisible(true);
        this.marker[curIndex].setAnimation(google.maps.Animation.BOUNCE);
        google.maps.event.trigger(this.marker[curIndex], "click");

        this.infowindow[curIndex].open(this.map, this.marker[curIndex]);
        this.map.panTo(this.office[curIndex]);

        // return false;
      });
    });

    this.hideAllMarkers();
    this.map.panBy(0, -120);
    this.map.setCenter(this.office[0]);
    this.marker[0].setVisible(true);
    this.infowindow[0].open(this.map, this.marker[0]);

    // let southWest = new google.maps.LatLng(25.192277, 55.296061);
    // let northEast = new google.maps.LatLng(25.185226, 55.303156);

    // let imageBounds = new google.maps.LatLngBounds(southWest, northEast);

    var imageBounds = {
      // south: 25.185022,
      // north: 25.191843,
      // east: 55.302866,
      // west: 55.29573,

      south: 25.183275797676583,
      north: 25.191936,
      east: 55.30308997905547,
      west: 55.29573,
    };

    let mapOverlay = new google.maps.GroundOverlay(
      this.overlayUrl,
      imageBounds
    );

    mapOverlay.setMap(this.map);
  }

  hideAllMarkers() {
    this.tabItem.forEach((currentValue, index) => {
      this.marker[index].setVisible(false);
      this.infowindow[index].close();
    });
  }
}
